import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import withStyles from 'react-jss';
import { Input } from 'antd';
import { DeleteOutlined, PlusCircleOutlined } from '@ant-design/icons';
import { Controller } from 'react-hook-form';

import GetField from '../Components/GetField';
import stylesCSS from '../styles';
import {
  getTotal,
  getProductTotalA,
  getProductTotalB,
  getProductTotalC,
} from './common-functions';

const AntInput = GetField(Input);

const ProcessForm = props => {
  const {
    classes,
    getValues,
    setValue,
    control,
    watch,
    processItem,
    processIndex,
    processAppend,
    processRemove,
    styleIndex,
  } = props;

  useEffect(() => {
    const qtyAvg =
      getValues(`styles[${styleIndex}].processes[${processIndex}].qtyAvg`) || 0;
    const price =
      getValues(`styles[${styleIndex}].processes[${processIndex}].price`) || 0;

    const total = +(+qtyAvg * +price).toFixed(2);

    setValue(`styles[${styleIndex}].processes[${processIndex}].total`, total);
  }, [
    watch(`styles[${styleIndex}].processes[${processIndex}].qtyAvg`),
    watch(`styles[${styleIndex}].processes[${processIndex}].price`),
  ]);

  useEffect(() => {
    const fabrics = getValues(`styles[${styleIndex}].fabrics`);
    const positions = getValues(`styles[${styleIndex}].positions`);
    const processes = getValues(`styles[${styleIndex}].processes`);

    setValue(
      `styles[${styleIndex}].total`,
      getTotal(fabrics, positions, processes)
    );

    const styles = getValues(`styles`);
    setValue(`productTotalA`, getProductTotalA(styles));
    setValue(`productTotalB`, getProductTotalB(styles));
    setValue(`productTotalC`, getProductTotalC(styles));
  }, [watch(`styles[${styleIndex}].processes[${processIndex}].total`)]);

  return (
    <tr>
      <td className={classes.inputTd}>
        <Controller
          name={`styles[${styleIndex}].processes[${processIndex}].process`}
          control={control}
          defaultValue={processItem.process}
          render={({ field }) => (
            <AntInput placeholder="Process" {...field} size="small" />
          )}
        />
      </td>
      <td className={classes.inputTd}>
        <Controller
          name={`styles[${styleIndex}].processes[${processIndex}].qtyAvg`}
          control={control}
          defaultValue={processItem.qtyAvg}
          render={({ field }) => (
            <AntInput
              placeholder="Qty/Avg"
              {...field}
              type="number"
              min={0}
              size="small"
            />
          )}
        />
      </td>
      <td className={classes.inputTd}>
        <Controller
          name={`styles[${styleIndex}].processes[${processIndex}].price`}
          control={control}
          defaultValue={processItem.price}
          render={({ field }) => (
            <AntInput
              placeholder="Price"
              {...field}
              type="number"
              min={0}
              size="small"
            />
          )}
        />
      </td>
      <td className={classes.inputTd}>
        <Controller
          name={`styles[${styleIndex}].processes[${processIndex}].total`}
          control={control}
          defaultValue={processItem.total}
          render={({ field }) => (
            <AntInput
              placeholder="Total"
              {...field}
              type="number"
              min={0}
              size="small"
              disabled
            />
          )}
        />
      </td>
      <td className={classes.inputTd}>
        <DeleteOutlined
          onClick={() => {
            const processes = getValues(`styles[${styleIndex}].processes`);

            if (processes && processes.length > 10 && processIndex >= 10) {
              processRemove(processIndex);
            }
          }}
        />
        &nbsp; &nbsp;
        <PlusCircleOutlined
          onClick={() =>
            processAppend({
              process: null,
              qtyAvg: null,
              price: null,
              total: null,
            })
          }
        />
      </td>
    </tr>
  );
};

ProcessForm.propTypes = {
  classes: PropTypes.object.isRequired,
  getValues: PropTypes.func.isRequired,
  setValue: PropTypes.func.isRequired,
  control: PropTypes.any.isRequired,
  watch: PropTypes.func.isRequired,
  processItem: PropTypes.object.isRequired,
  processIndex: PropTypes.number.isRequired,
  processAppend: PropTypes.func.isRequired,
  processRemove: PropTypes.func.isRequired,
  styleIndex: PropTypes.number.isRequired,
};

export default withStyles(stylesCSS)(ProcessForm);
